// extracted by mini-css-extract-plugin
export default {"column":"EbuZy","variants":"oNMxR","readOnlyVariant":"spE3N","title":"pg1Jg","variant":"xzKVi","variantMenu":"Rgc5k","button":"huzHj"};